module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "our-brand container"
  }, [_c('h2', [_vm._v(_vm._s(this.title))]), _vm._v(" "), _c('div', {
    staticClass: "blocks brand-tails"
  }, [(_vm.imageBlock1) ? _c('div', {
    staticClass: "block brand-tail block--grey",
    class: {
      'block--active': 0 === _vm.activeBrand
    },
    on: {
      "click": function($event) {
        return _vm.setActiveBrand($event)
      }
    }
  }, [_c('div', {
    staticClass: "brand-tail__header"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageBlock1,
      "alt": "logo",
      "data-index": "0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content",
    class: {
      'brand-tail__content--active': 0 === _vm.activeBrand
    }
  }, [_c('div', {
    staticClass: "brand-tail__content-top"
  }, [_c('div', {
    staticClass: "cross",
    on: {
      "click": _vm.hideContent
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content-inner"
  }, [(_vm.imageBlock1) ? _c('div', {
    staticClass: "brand-tail__content-image",
    style: ({
      'background-color': _vm.images[0].left_background
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.imageBlock1,
      "alt": "image"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content-description",
    style: ({
      'background-color': _vm.images[0].right_background,
      'color': _vm.images[0].right_text_color
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.images[0].description)
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block block--white"
  }), _vm._v(" "), _c('div', {
    staticClass: "block block--triple"
  }, [_c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(this.description))])]), _vm._v(" "), (_vm.imageBlock2) ? _c('div', {
    staticClass: "block block--white"
  }) : _vm._e(), _vm._v(" "), (_vm.imageBlock2) ? _c('div', {
    staticClass: "block block--grey",
    class: {
      'block--active': 1 === _vm.activeBrand
    },
    on: {
      "click": function($event) {
        return _vm.setActiveBrand($event)
      }
    }
  }, [_c('div', {
    staticClass: "brand-tail__header"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageBlock2,
      "alt": "logo",
      "data-index": "1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content",
    class: {
      'brand-tail__content--active': 1 === _vm.activeBrand
    }
  }, [_c('div', {
    staticClass: "brand-tail__content-top"
  }, [_c('div', {
    staticClass: "cross",
    on: {
      "click": _vm.hideContent
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content-inner"
  }, [(_vm.imageBlock2) ? _c('div', {
    staticClass: "brand-tail__content-image",
    style: ({
      'background-color': _vm.images[1].left_background
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.imageBlock2,
      "alt": "image"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content-description",
    style: ({
      'background-color': _vm.images[1].right_background,
      'color': _vm.images[1].right_text_color
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.images[1].description)
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.imageBlock3) ? _c('div', {
    staticClass: "block block--white"
  }) : _vm._e(), _vm._v(" "), (_vm.imageBlock3) ? _c('div', {
    staticClass: "block block--grey",
    class: {
      'block--active': 2 === _vm.activeBrand
    },
    on: {
      "click": function($event) {
        return _vm.setActiveBrand($event)
      }
    }
  }, [_c('div', {
    staticClass: "brand-tail__header"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageBlock3,
      "alt": "logo",
      "data-index": "2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content",
    class: {
      'brand-tail__content--active': 2 === _vm.activeBrand
    }
  }, [_c('div', {
    staticClass: "brand-tail__content-top"
  }, [_c('div', {
    staticClass: "cross",
    on: {
      "click": _vm.hideContent
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content-inner"
  }, [(_vm.imageBlock3) ? _c('div', {
    staticClass: "brand-tail__content-image",
    style: ({
      'background-color': _vm.images[2].left_background
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.imageBlock3,
      "alt": "image"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content-description",
    style: ({
      'background-color': _vm.images[2].right_background,
      'color': _vm.images[2].right_text_color
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.images[2].description)
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.imageBlock4) ? _c('div', {
    staticClass: "block block--white"
  }) : _vm._e(), _vm._v(" "), (_vm.imageBlock4) ? _c('div', {
    staticClass: "block block--grey",
    class: {
      'block--active': 3 === _vm.activeBrand
    },
    on: {
      "click": function($event) {
        return _vm.setActiveBrand($event)
      }
    }
  }, [_c('div', {
    staticClass: "brand-tail__header"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageBlock4,
      "alt": "logo",
      "data-index": "3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content",
    class: {
      'brand-tail__content--active': 3 === _vm.activeBrand
    }
  }, [_c('div', {
    staticClass: "brand-tail__content-top"
  }, [_c('div', {
    staticClass: "cross",
    on: {
      "click": _vm.hideContent
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content-inner"
  }, [(_vm.imageBlock4) ? _c('div', {
    staticClass: "brand-tail__content-image",
    style: ({
      'background-color': _vm.images[3].left_background
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.imageBlock4,
      "alt": "image"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content-description",
    style: ({
      'background-color': _vm.images[3].right_background,
      'color': _vm.images[3].right_text_color
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.images[3].description)
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.imageBlock5) ? _c('div', {
    staticClass: "block block--white"
  }) : _vm._e(), _vm._v(" "), (_vm.imageBlock5) ? _c('div', {
    staticClass: "block block--grey",
    class: {
      'block--active': 4 === _vm.activeBrand
    },
    on: {
      "click": function($event) {
        return _vm.setActiveBrand($event)
      }
    }
  }, [_c('div', {
    staticClass: "brand-tail__header"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageBlock5,
      "alt": "logo",
      "data-index": "4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content",
    class: {
      'brand-tail__content--active': 4 === _vm.activeBrand
    }
  }, [_c('div', {
    staticClass: "brand-tail__content-top"
  }, [_c('div', {
    staticClass: "cross",
    on: {
      "click": _vm.hideContent
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content-inner"
  }, [(_vm.imageBlock5) ? _c('div', {
    staticClass: "brand-tail__content-image",
    style: ({
      'background-color': _vm.images[4].left_background
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.imageBlock5,
      "alt": "image"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content-description",
    style: ({
      'background-color': _vm.images[4].right_background,
      'color': _vm.images[4].right_text_color
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.images[4].description)
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.imageBlock6) ? _c('div', {
    staticClass: "block block--white"
  }) : _vm._e(), _vm._v(" "), (_vm.imageBlock6) ? _c('div', {
    staticClass: "block block--grey",
    class: {
      'block--active': 5 === _vm.activeBrand
    },
    on: {
      "click": function($event) {
        return _vm.setActiveBrand($event)
      }
    }
  }, [_c('div', {
    staticClass: "brand-tail__header"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageBlock6,
      "alt": "logo",
      "data-index": "5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content",
    class: {
      'brand-tail__content--active': 5 === _vm.activeBrand
    }
  }, [_c('div', {
    staticClass: "brand-tail__content-top"
  }, [_c('div', {
    staticClass: "cross",
    on: {
      "click": _vm.hideContent
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content-inner"
  }, [(_vm.imageBlock6) ? _c('div', {
    staticClass: "brand-tail__content-image",
    style: ({
      'background-color': _vm.images[5].left_background
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.imageBlock6,
      "alt": "image"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brand-tail__content-description",
    style: ({
      'background-color': _vm.images[5].right_background,
      'color': _vm.images[5].right_text_color
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.images[5].description)
    }
  })])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89cb2314","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlockOurBrand.vue
// module id = 353
// module chunks = 0